import { consentSnapshot } from './consentGate'
import { markConsentTiming } from './consentTiming'

/** The ad providers that count toward `first_ad_visible`. */
export type AdRequestProvider = 'display' | 'taboola' | 'outbrain' | 'primis'

export const FIRST_AD_REQUEST_MARK = 'first-ad-request'

let marked = false

/**
 * Records the page load's first ad request, from whichever provider asks
 * first, with the consent decision in effect at that moment:
 * `consent-bootstrap:first-ad-request:<provider>:<state>`. The state is read
 * live, not rebuilt from the decision marks, because those mark each state
 * only once and miss a return to an earlier one.
 */
export function markFirstAdRequest(provider: AdRequestProvider): void {
  if (marked) return
  marked = true
  const state = consentSnapshot()?.state ?? 'none'
  markConsentTiming(`${FIRST_AD_REQUEST_MARK}:${provider}:${state}`)
}

export function resetFirstAdRequestForTests(): void {
  marked = false
}
